'use client'

import { useState } from 'react'
import { useTranslations } from 'next-intl'

export function ForgotPasswordForm({ apiBaseUrl }: { apiBaseUrl: string }) {
  const t = useTranslations('forgotPassword')
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [done, setDone] = useState(false)
  const [errorKey, setErrorKey] = useState<'rateLimited' | 'GENERIC' | null>(null)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setSubmitting(true)
    setErrorKey(null)
    try {
      const res = await fetch(`${apiBaseUrl}/api/v1/klant/wachtwoord-vergeten`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      })
      if (res.status === 429) {
        setErrorKey('rateLimited')
      } else {
        setDone(true)
      }
    } catch {
      setErrorKey('GENERIC')
    } finally {
      setSubmitting(false)
    }
  }

  if (done) {
    return (
      <div className="rounded-lg border border-green-200 bg-green-50 p-4 text-sm text-green-800">
        {t('confirmation')}
      </div>
    )
  }

  return (
    <form onSubmit={submit} className="space-y-4">
      {errorKey && (
        <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800">
          {errorKey === 'rateLimited' ? t('rateLimited') : t('error.GENERIC')}
        </div>
      )}
      <div>
        <label
          htmlFor="email"
          className="mb-1 block text-sm font-medium text-[#1A1A18]"
        >
          {t('emailLabel')}
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-lg border border-[#CED0C8] bg-white px-3 py-2 text-sm focus:border-[#CCFA78] focus:outline-none focus:ring-2 focus:ring-[#CCFA78]/40"
        />
      </div>
      <button
        type="submit"
        disabled={submitting}
        className="inline-block rounded-lg bg-[#1A1A18] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#2a2a26] disabled:opacity-60"
      >
        {t('submit')}
      </button>
    </form>
  )
}
